<template>
  <div>
    <AdminTableOfContentsDrawer
      :value="isSupportNavbarOpen"
      :sections="faqsByTopic"
      item-text-key="question"
      @input="isSupportNavbarOpen = $event"
    />
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'

import _groupBy from 'lodash/groupBy'
import FaqModel from '@/models/FaqModel'

import AdminTableOfContentsDrawer from '@/components/AdminTableOfContentsDrawer'

export default {
  name: 'AdminSupportNavDrawer',
  components: {
    AdminTableOfContentsDrawer,
  },
  data() {
    return {}
  },
  computed: {
    ...mapFields('admin', ['isSupportNavbarOpen']),
    faqs() {
      return FaqModel.all()
    },
    faqsByTopic() {
      return _groupBy(this.faqs, 'topic')
    },
  },
}
</script>
